export const PhoneService = {
  normalizePhone(phone: string) {
    if (phone.indexOf("(") !== -1) {
      phone = phone.substring(phone.indexOf("(") + 1).trim();
      if (phone.indexOf(")") !== -1) {
        phone = phone.substring(0, phone.indexOf(")"));
      }
    }

    phone = phone.replace(/-/g, "").trim().toLowerCase();

    if (phone.indexOf("wbmason") !== -1) {
      phone = phone.replace("wbmason", "9262766");
    }

    return phone;
  },
};
